import React from 'react';

const useOpenableController = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const onClose = React.useCallback(() => setIsOpen(false), [setIsOpen]);
  const onOpen = React.useCallback(() => setIsOpen(true), [setIsOpen]);
  const onToggle = React.useCallback(() => setIsOpen(prev => !prev), [setIsOpen]);

  return {
    isOpen,
    onClose,
    onOpen,
    onToggle,
  };
};

export default useOpenableController;
